let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '手机号',
        props: 'custPhone',
        minWidth: 120,
    },
    {
        label: '时间',
        props: 'chargeDay',
        minWidth: 100,
    },
    {
        label: '充电金额',
        props: 'tActFee',
        minWidth: 80,
    },
    {
        label: '充电站',
        props: 'stationName',
        minWidth: 160,
    }
];

pageConfig.newlistColumns = [
    {
        label: '手机号',
        props: 'custPhone',
        minWidth: 100,
    },
    {
        label: '时间',
        props: 'chargeDay',
        minWidth: 90,
    },
    {
        label: '充电金额',
        props: 'tActFee',
    },
    {
        label: '充电站',
        props: 'stationName',
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
    maxHeight:'18.1rem',
    herderStyle:{background:colorRGB2Hex('rgba(250,250,250,1)'),color:'#8F9BB3'}
};

// 将rgb颜色转成hex
function colorRGB2Hex(color) {
    var rgb = color.split(',');
    var r = parseInt(rgb[0].split('(')[1]);
    var g = parseInt(rgb[1]);
    var b = parseInt(rgb[2].split(')')[0]);

    var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return hex;
}

pageConfig.firstFormRules = {
    handlerRemark: [{
        required: true,
        message: '请填写备注',
        trigger: 'blur'
    }],
    respondChargeVal: [
        {
        required: true,
        message: '请输入应付度电',
        trigger: 'blur'
    }
    ],
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

export default pageConfig;